module.exports = __webpack_public_path__ + "img/8ne.92d021f6.svg";